import { ActivityFormat, ActivityVariance, TournamentFormat, Weight } from "@/types";

import type { StringTranslationKey } from "./";

export const WEIGHT_KEYS: Record<Weight, StringTranslationKey> = {
  [Weight.Low]: "activity.weightLow",
  [Weight.Normal]: "activity.weightNormal",
  [Weight.High]: "activity.weightHigh",
  [Weight.Double]: "activity.weightDouble",
};

export const VARIANCE_KEYS: Record<ActivityVariance, StringTranslationKey> = {
  [ActivityVariance.Low]: "activity.varianceLow",
  [ActivityVariance.Medium]: "activity.varianceMedium",
  [ActivityVariance.High]: "activity.varianceHigh",
};

export const FORMAT_KEYS: Record<ActivityFormat, StringTranslationKey> = {
  [ActivityFormat.FreeForAll]: "activity.formatFfa",
  [ActivityFormat.Teams]: "activity.formatTeams",
  [ActivityFormat.Tournament]: "activity.formatTournament",
};

export const TOURNAMENT_FORMAT_KEYS: Record<TournamentFormat, StringTranslationKey> = {
  [TournamentFormat.SingleElimination]: "activity.tournamentFormatSingle",
  [TournamentFormat.DoubleElimination]: "activity.tournamentFormatDouble",
  [TournamentFormat.RoundRobin]: "activity.tournamentFormatRoundRobin",
  [TournamentFormat.Swiss]: "activity.tournamentFormatSwiss",
};

export const TOURNAMENT_FORMAT_DESCS: Record<TournamentFormat, StringTranslationKey> = {
  [TournamentFormat.SingleElimination]: "activity.tournamentFormatSingleDesc",
  [TournamentFormat.DoubleElimination]: "activity.tournamentFormatDoubleDesc",
  [TournamentFormat.RoundRobin]: "activity.tournamentFormatRoundRobinDesc",
  [TournamentFormat.Swiss]: "activity.tournamentFormatSwissDesc",
};
